import React from 'react';
import { Route, Routes } from 'react-router-dom';
import SignupForm from './SignUp.tsx';

const MetaForm:React.FC = () => {
    return (
        <>
            <Routes>
                <Route  path={`/sign-up`} element={<SignupForm />} />
            </Routes>
        </>
    );
};
export default MetaForm;
